module.exports = __webpack_public_path__ + "img/img_06.61b28ba0.jpg";